import { render, staticRenderFns } from "./IssuesLayout.vue?vue&type=template&id=444efeaa&scoped=true"
import script from "./IssuesLayout.vue?vue&type=script&lang=js"
export * from "./IssuesLayout.vue?vue&type=script&lang=js"
import style0 from "./IssuesLayout.vue?vue&type=style&index=0&id=444efeaa&prod&lang=scss&scoped=true"
import style1 from "./IssuesLayout.vue?vue&type=style&index=1&id=444efeaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444efeaa",
  null
  
)

export default component.exports